import React from 'react';
import { StatsCard } from './shared.jsx';

const BIConfigOverview = ({ configMetrics, onCreate }) => {
  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 shadow-sm">
      <div className="p-6 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="max-w-2xl">
          <div className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-200">
            Super admin only
          </div>
          <h2 className="mt-4 text-3xl font-semibold text-gray-900 dark:text-gray-100">BI configuration</h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
            Configure project-level visibility rules and module-specific feature flags from a single admin screen.
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={onCreate}
            className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition-colors shadow-sm"
          >
            Create configuration
          </button>
        </div>
      </div>

      <div className="overflow-x-auto px-6 pb-6">
        <div className="flex min-w-max gap-3">
          <StatsCard label="Configurations" value={configMetrics.totalConfigs} helper="Active project-level rules" />
          <StatsCard label="Modules available" value={configMetrics.totalModules} helper="Currently configurable modules" />
          <StatsCard label="Admin-only rules" value={configMetrics.adminRestricted} helper="Entries restricting content to admins" />
          <StatsCard label="Features enabled" value={configMetrics.enabledFeatures} helper="Client-specific features turned on" />
          <StatsCard label="Updated today" value={configMetrics.updatedToday} helper="Recently changed configurations" />
        </div>
      </div>
    </div>
  );
};

export default BIConfigOverview;
